"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_POSTURES_MAP = exports.ALL_POSTURES_VALUES = exports.ALL_POSTURES = exports.ALL_INJURIES_VALUES = exports.INJURY_DESCRIPTION_MAP = exports.ALL_INJURIES = void 0;
exports.ALL_INJURIES = {
    'neck': 'Neck',
    'shoulder': 'Shoulder',
    'hip': 'Hip',
    'knee': 'Knee',
    'ankle': 'Ankle',
    'prolapse': 'Prolapse',
    'pubicPain': 'Pubic Pain',
    'dr': 'Diastisis Recti',
    'carpalTunnel': 'Carpal Tunnel',
    'groinPain': 'Groin Pain',
    'sacrumPain': 'Sacrum Pain',
    'hypertonic': 'Hypertonic',
    'leakage': 'Leakage',
    'csection': 'C-Section',
    'roundLigament': 'Round Ligament Pain'
};
exports.INJURY_DESCRIPTION_MAP = Object.keys(exports.ALL_INJURIES).map(k => ({ value: k, description: exports.ALL_INJURIES[k] }));
exports.ALL_INJURIES_VALUES = Object.keys(exports.ALL_INJURIES);
exports.ALL_POSTURES = {
    'neutral': 'Neutral',
    'kyphotic': 'Kyphotic',
    'flare': 'Flare',
    'tucker': 'Tucker',
    'lordosis': 'Lordosis',
    'valgus': 'Valgus',
    'gripper': 'Gripper',
};
exports.ALL_POSTURES_VALUES = Object.keys(exports.ALL_POSTURES);
exports.ALL_POSTURES_MAP = Object.keys(exports.ALL_POSTURES).map(k => ({ value: k, description: exports.ALL_POSTURES[k] }));
//# sourceMappingURL=physicalConditions.js.map